import React, { useEffect, useMemo, useState } from "react";
import { Table, Button, Divider, Card, Tag, Icon, Input, Row, Col, Tooltip, message, Badge } from "antd";
import { withRouter } from "react-router-dom";
import api from "../../../services/api";

const { Search } = Input;
const panelStyle = {
  borderRadius: 12,
  boxShadow: "3px 8px 0px rgba(0,0,0,0.01)",
  border: "1px solid #f0f0f0",
  fontSize: 14
};
const headerStyle = { fontSize: 16, fontWeight: 700 };

const UserList = (props) => {
  const { history } = props;
  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState([]);
  const [isAdmin, setIsAdmin] = useState(false);
  const [search, setSearch] = useState("");

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const res = await api.get("/pasta/users/");
      const data = res && res.data ? res.data : [];
      const mapped = data.map(function mapUser(value) {
        return {
          ...value,
          key: value.id
        };
      });
      setUsers(mapped);

      const currentUserId = parseInt(localStorage.getItem("auth_userid") || "0", 10);
      const adminFromList = mapped.some(function isCurrentUserAdmin(u) {
        return Number(u.id) === currentUserId && u.is_superuser === true;
      });
      // Fallback if current user not found in list (pagination?) or trust localstorage for UI
      const localAdmin = localStorage.getItem("auth_superuser") === "true";
      setIsAdmin(adminFromList || localAdmin);
    } catch (err) {
      console.error(err);
      message.error("Não foi possível carregar a lista de usuários.");
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = function handleEdit(record) {
    history.push({ pathname: "/user_update", state: { record: record } });
  };

  const handleChangePassword = function handleChangePassword(record) {
    if (!isAdmin) {
      message.error("Apenas administradores podem alterar a senha de outros usuários.");
      return;
    }
    history.push({ pathname: "/user_update/password", state: { record: record } });
  };

  const filteredUsers = useMemo(
    function filterUsers() {
      if (!search) {
        return users;
      }
      const term = search.toLowerCase();
      return users.filter(function filterItem(item) {
        const name = item.nome ? item.nome.toLowerCase() : "";
        const username = item.username ? item.username.toLowerCase() : "";
        const email = item.email ? item.email.toLowerCase() : "";
        return (
          name.indexOf(term) > -1 ||
          username.indexOf(term) > -1 ||
          email.indexOf(term) > -1
        );
      });
    },
    [users, search]
  );

  const totalActive = useMemo(
    function getTotalActive() {
      return users.filter(function onlyActive(u) {
        return u.is_active;
      }).length;
    },
    [users]
  );

  const totalAdmins = useMemo(
    function getTotalAdmins() {
      return users.filter(function onlyAdmin(u) {
        return u.is_superuser;
      }).length;
    },
    [users]
  );

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      width: 70,
      render: function renderId(value) {
        return <Badge status="processing" text={value} />;
      }
    },
    {
      title: "Usuário",
      key: "nome",
      render: function renderUser(text, record) {
        return (
          <div>
            <div style={{ fontWeight: 700, fontSize: 15 }}>{record.nome || record.username}</div>
            <div style={{ color: "#8c8c8c" }}>@{record.username}</div>
          </div>
        );
      }
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      render: function renderEmail(value) {
        return value || "—";
      }
    },
    {
      title: "Status",
      dataIndex: "is_active",
      key: "is_active",
      render: function renderStatus(value, record) {
        return (
          <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
            <Tag color={value ? "green" : "red"}>{value ? "Ativo" : "Inativo"}</Tag>
            {record.is_superuser ? <Tag color="geekblue">Admin</Tag> : null}
          </div>
        );
      }
    },
    {
      title: "Ações",
      key: "action",
      width: 260,
      render: function renderActions(text, record) {
        return (
          <span>
            <Tooltip title="Editar usuário">
              <Button icon="edit" onClick={function onClick() { handleEdit(record); }} size="small">
                Editar
              </Button>
            </Tooltip>
            {isAdmin ? (
              <React.Fragment>
                <Divider type="vertical" />
                <Tooltip title="Atualizar senha">
                  <Button onClick={function onClick() { handleChangePassword(record); }} icon="lock" size="small">
                    Senha
                  </Button>
                </Tooltip>
              </React.Fragment>
            ) : null}
          </span>
        );
      }
    }
  ];

  return (
    <div style={{ padding: 16 }}>
      <Row gutter={16} style={{ marginBottom: 16 }}>
        <Col xs={24} sm={12} md={8} style={{ marginTop: 12 }}>
          <Card bodyStyle={{ display: "flex", alignItems: "center" }} style={panelStyle}>
            <Icon type="team" style={{ fontSize: 28, color: "#1890ff", marginRight: 12 }} />
            <div>
              <div style={{ color: "#8c8c8c", fontSize: 12 }}>Usuários cadastrados</div>
              <div style={{ fontSize: 20, fontWeight: 700 }}>{users.length}</div>
            </div>
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8} style={{ marginTop: 12 }}>
          <Card bodyStyle={{ display: "flex", alignItems: "center" }} style={panelStyle}>
            <Icon type="safety" style={{ fontSize: 28, color: "#52c41a", marginRight: 12 }} />
            <div>
              <div style={{ color: "#8c8c8c", fontSize: 12 }}>Ativos</div>
              <div style={{ fontSize: 20, fontWeight: 700 }}>{totalActive}</div>
            </div>
          </Card>
        </Col>
        <Col xs={24} sm={24} md={8} style={{ marginTop: 12 }}>
          <Card bodyStyle={{ display: "flex", alignItems: "center" }} style={panelStyle}>
            <Icon type="crown" style={{ fontSize: 28, color: "#faad14", marginRight: 12 }} />
            <div>
              <div style={{ color: "#8c8c8c", fontSize: 12 }}>Administradores</div>
              <div style={{ fontSize: 20, fontWeight: 700 }}>{totalAdmins}</div>
            </div>
          </Card>
        </Col>
      </Row>

      <Card
        title={
          <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <Icon type="user" style={{ marginRight: 8 }} />
            Usuários
          </span>
        }
        extra={
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
            <Button onClick={fetchUsers} icon="reload" style={{ marginRight: 8 }} size="large">
              Atualizar
            </Button>
            <Button type="primary" icon="plus" onClick={function onClick() { handleEdit({}); }} size="large">
              Novo Usuário
            </Button>
          </div>
        }
        style={panelStyle}
        headStyle={headerStyle}
      >
        <div style={{ marginBottom: 12, display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 8 }}>
          <Search
            placeholder="Buscar por nome, login ou email"
            style={{ maxWidth: 420, flex: 1, minWidth: 260 }}
            onSearch={function onS(value) { setSearch(value); }}
            onChange={function onChange(event) { setSearch(event.target.value); }}
            value={search}
            allowClear
            size="large"
          />
        </div>
        <Table
          dataSource={filteredUsers}
          columns={columns}
          loading={loading}
          pagination={{ pageSize: 12 }}
          size="middle"
          scroll={{ x: true }}
          rowKey="id"
        />
      </Card>
    </div>
  );
}

export default withRouter(UserList);



// WEBPACK FOOTER //
// ./src/pages/Usuario/Listagem/index.js